module.exports = __webpack_public_path__ + "static/media/PokeApp.3406cab8.webp";